/**
 * Extracts the file ID from a Google Drive URL
 * @param {string} url - The Google Drive URL
 * @returns {string|null} - The extracted file ID or null if not found
 */
export const getGoogleDriveFileId = (url) => {
  try {
    const urlObject = new URL(url);
    const filePathMatch = urlObject.pathname.match(/\/file\/d\/([^/]+)/);
    if (filePathMatch) {
      return filePathMatch[1];
    }
    return null;
  } catch (error) {
    console.error('Error parsing Google Drive URL:', error);
    return null;
  }
};
